import { UUIDModel } from "@/models/uuid-model";

export default class UserSuggestion extends UUIDModel<UserSuggestion> {
  public surname = "";
  public displayName = "";
  public mail = "";
}
